import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";

export interface Workout {
  name: string;
  date: string;
  duration: string;
  distance: string;
  intensity: "High" | "Medium" | "Low";
}

interface RecentTrainingSetsCardProps {
  workouts: Workout[];
}

/**
 * Card component displaying recent training sets/workouts
 */
export function RecentTrainingSetsCard({ workouts }: RecentTrainingSetsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Training Sets</CardTitle>
        <CardDescription>Your latest workouts and performance</CardDescription>
      </CardHeader>

      <CardContent>
        <div className="space-y-4">
          {workouts.map((workout, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 rounded-lg border"
            >
              <div className="space-y-1">
                <p className="font-medium">{workout.name}</p>
                <p className="text-sm text-muted-foreground">
                  {workout.date} • {workout.duration} • {workout.distance}
                </p>
              </div>

              <Badge
                variant={
                  workout.intensity === "High"
                    ? "default"
                    : workout.intensity === "Medium"
                    ? "secondary"
                    : "outline"
                }
              >
                {workout.intensity}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

